export default __webpack_public_path__ + "static/media/try-again.4f930231.gif";